const BASE_URL = `https://api.ibadansouthanglicandiocese.org.ng/`;
const DEFAULT_LOGO = `${BASE_URL}logos/1741869083_site_icon.png`;

const ImageHelper = ({ src, alt, className = "w-full h-60 object-cover" }) => {
    // 1. Determine the correct source
    const getFullSrc = () => {
        if (!src) return DEFAULT_LOGO;
        if (src.startsWith('http')) return src;
        return `${BASE_URL}${src}`;
    };

    return (
        <>
            <img
                src={getFullSrc()}
                alt={alt || "Event image"}
                className={className}
                // Optional: Handle broken links that might still return a 404
                onError={(e) => { e.target.src = DEFAULT_LOGO; }}
            />
        </>
    );
};

export default ImageHelper; 